export default __webpack_public_path__ + "static/media/4-2.2d669d89.jpg";